import { HttpStatusCode } from "axios";
import IPartner from "../models/partner/IPartner";
import networkService from "./NetworkService";

class PartnerService {

    /**
     * @description Gets all partners
     */
    async getPartners(): Promise<IPartner[]> {
        const result = await networkService.get<IPartner[]>(`/partners`);

        if (!result.isSuccessful) {
            throw result.data;
        }

        if (result.status === HttpStatusCode.NoContent) {
            return [];
        }
        
        const partners = (result.data as IPartner[])
            .sort((a, b) => a.name.localeCompare(b.name));

        return partners;
    }

    /**
     * @description Gets the specified partner
     * @param {string} id The ID of the partner to be returned
     */
    async getPartner(id: string): Promise<IPartner> {
        const result = await networkService.get<IPartner>(`/partner/${id}`);

        if (result.isSuccessful) {
            return result.data as IPartner;
        }

        throw result.data;
    }

    /**
     * @description Creates a new partner
     * @param {IPartner} partner The partner to be created
     */
    async createPartner(partner: IPartner): Promise<string> {
        const result = await networkService.put<IPartner, string>(`/partner`, partner);

        if (result.isSuccessful) {
            return result.data as string;
        }

        throw result.data;
    }
    
    /**
     * @description Updates the specified partner
     * @param {IPartner} partner The partner to be updated
     */
    async updatePartner(partner: IPartner): Promise<void> {
        const result = await networkService.patch(`/partner`, partner);

        if (result.isSuccessful) {
            return;
        }

        throw result.data;
    }

    /**
     * @description Deletes the specified partner
     * @param {string} id The ID of the partner to be deleted
     */
    async deletePartner(id: string): Promise<boolean> {
        const result = await networkService.delete(`/partner/${id}`);
        return result.isSuccessful;
    }

}

const partnerService = new PartnerService();
export default partnerService;
